<ng-container *ngIf="product$ | async as product">
  <h1 class="product-detail__title" data-cy="product-name">
    {{ product.name }}
  </h1>
  <div
    *ngIf="
      product.predecessors?.length > 0 || isVariant(product.ebProductType) || product.expirationDate
    "
    class="product-detail-supplementary"
  >
    <div *ngIf="product.predecessors?.length > 0">
      {{
        'productDetail.predecessors'
          | cxTranslate: { predecessors: product.predecessors?.join(', ') }
      }}
    </div>
    <div
      *ngIf="isVariant(product.ebProductType)"
      class="product-detail__codes"
      [attr.data-cy]="'product-detail-code'"
    >
      <div class="product-detail__code">
        {{ 'productDetail.code' | cxTranslate: { code: product.code } }}
      </div>
    </div>
    <div class="product-detail__customer-material" *ngIf="product.customerMaterialNumber">
      {{
        'productDetail.customerMaterialNumber'
          | cxTranslate: { code: product.customerMaterialNumber }
      }}
    </div>
    <div *ngIf="product.expirationDate">
      <div *ngIf="localizedDateEmitter$ | async">
        {{ 'productDetail.expirationDateLabel' | cxTranslate: { date: localizedDate } }}
      </div>
    </div>
  </div>

  <div class="product-details__common">
    <!-- DOCUMENTS  -->
    <div *ngIf="product.documents?.length" class="product-detail__documents">
      <eb-document-link
        *ngIf="getDocumentByType(product.documents, EbMediaTypeEnum.MANUAL) as document"
        icon="tools"
        [title]="'productDetail.showManual'"
        [document]="document"
        [disabled]="!(isUserLoggedIn$ | async)"
        disabledHintToken="productDetail.document.signIn"
      ></eb-document-link>
      <eb-document-link
        *ngIf="getDocumentByType(product.documents, EbMediaTypeEnum.DATASHEET) as document"
        icon="file-download"
        [title]="'productDetail.showDataSheet'"
        [document]="document"
        [disabled]="!(isUserLoggedIn$ | async)"
        disabledHintToken="productDetail.document.signIn"
      ></eb-document-link>
    </div>
    <!-- FAVORITES -->
    <div
      *ngIf="isVariant(product.ebProductType)"
      class="product-detail__favorites-section-desktop"
      [ngClass]="{ 'product-detail__favorites--has-product': (this.isFavorite$ | async) }"
      [attr.disabled]="(isUserLoggedIn$ | async) ? undefined : true"
      [ngbTooltip]="
        (isUserLoggedIn$ | async) ? undefined : ('productDetail.favorites.signIn' | cxTranslate)
      "
    >
      <eb-dropdown
        *ngIf="favoritesList$ | async as favoritesList"
        [attr.disabled]="(isUserLoggedIn$ | async) ? undefined : true"
        alignment="left"
        [attr.data-cy]="'variant-favorite-link'"
      >
        <div
          class="product-detail__add-to-favorites"
          data-cy="add-to-default-fav-list"
          (click)="toggleFavorite($event)"
          trigger
        >
          <em class="fas fa-star"></em>
        </div>
        <div
          class="product-detail__favorites-dropdown-trigger"
          trigger
          data-cy="add-to-custom-fav-list"
        >
          <span>{{ 'productDetail.favorites.title' | cxTranslate }}</span>
          <em class="fas fa-angle-down"></em>
        </div>
        <ul class="product-detail__favorites-list" *ngIf="isUserLoggedIn$ | async" content>
          <eb-grouped-favorites
            *ngIf="groupedFavoritesList$ | async as grouped"
            [grouped]="grouped"
            [product]="product"
            [price]="price"
          >
          </eb-grouped-favorites>
        </ul>
      </eb-dropdown>
      <eb-spinner *ngIf="this.favoritesListLoading$ | async" size="1"></eb-spinner>
    </div>
    <div
      *ngIf="isVariant(product.ebProductType)"
      class="product-detail__favorites-section-mobile"
      [ngClass]="{ 'product-detail__favorites--has-product': (this.isFavorite$ | async) }"
      [attr.disabled]="(isUserLoggedIn$ | async) ? undefined : true"
      [ngbTooltip]="
        (isUserLoggedIn$ | async) ? undefined : ('productDetail.favorites.signIn' | cxTranslate)
      "
      [triggers]="'click:blur'"
    >
      <eb-dropdown
        *ngIf="favoritesList$ | async as favoritesList"
        [attr.disabled]="(isUserLoggedIn$ | async) ? undefined : true"
        alignment="left"
        [attr.data-cy]="'variant-favorite-link'"
      >
        <div
          class="product-detail__add-to-favorites"
          data-cy="add-to-default-fav-list"
          (click)="toggleFavorite($event)"
          trigger
        >
          <em class="fas fa-star"></em>
        </div>
        <div
          class="product-detail__favorites-dropdown-trigger"
          trigger
          data-cy="add-to-custom-fav-list"
        >
          <span>{{ 'productDetail.favorites.title' | cxTranslate }}</span>
          <em class="fas fa-angle-down"></em>
        </div>
        <ul class="product-detail__favorites-list" *ngIf="isUserLoggedIn$ | async" content>
          <eb-grouped-favorites
            *ngIf="groupedFavoritesList$ | async as grouped"
            [grouped]="grouped"
            [product]="product"
            [price]="price"
          >
          </eb-grouped-favorites>
        </ul>
      </eb-dropdown>
      <eb-spinner *ngIf="this.favoritesListLoading$ | async" size="1"></eb-spinner>
    </div>
  </div>

  <!-- Product Price to see login/register for anonymous guest users & only for variants -->
  <ng-container *ngIf="!(isUserLoggedIn$ | async) && isVariant(product.ebProductType)">
    <div class="product-detail__login-registration-container">
      <div class="product-detail__pre-label">
        {{ 'productDetail.price.auth.price' | cxTranslate }}
      </div>

      <div class="product-detail__login-text">
        <button
          class="product-detail__login-btn"
          data-cy="login-button"
          (click)="loginWithSapIDP()"
          [attr.data-rendermode]="reportRenderMode('anonymous')"
        >
          {{ 'productDetail.price.auth.login' | cxTranslate }}
        </button>
        <span [innerHTML]="'productDetail.price.auth.seperator' | cxTranslate"></span>
        <div
          *ngIf="linkComponent$ | async as linkComponent"
          class="product-detail__registration-link-container"
        >
          <cx-generic-link
            [url]="linkComponent.url"
            [target]="linkComponent.target"
            [style]="linkComponent.styleAttributes"
          >
            {{ 'productDetail.price.auth.register' | cxTranslate }}
          </cx-generic-link>
        </div>
        <span [innerHTML]="'productDetail.price.auth.post' | cxTranslate"></span>
      </div>
    </div>
  </ng-container>

  <!-- IS L1, L2 OR L3 -->
  <ng-container *ngIf="isVariant(product.ebProductType)">
    <ng-container *ngIf="product.orderable; else notOrderableSection">
      <!-- PRICE -->
      <ng-container *ngIf="priceLoading; else showPrice">
        <eb-spinner class="product-detail__price-spinner"></eb-spinner>
      </ng-container>
      <ng-template #showPrice>
        <ng-container *ngIf="hasPrice(product) && isUserLoggedIn$ | async">
          <div class="product-detail__prices">
            <ng-container *ngIf="hasScalePrice(product); else showSinglePrice">
              <div
                *ngFor="let scalePrice of price.items[0].scales"
                class="product-detail__scale-price-wrapper"
              >
                {{
                  'productDetail.scalePriceLabel'
                    | cxTranslate: { quantity: scalePrice.quantity, unit: price.items[0].unit }
                }}
                <span class="product-detail__price" [attr.data-cy]="'variant-detail-price'">
                  {{ scalePrice.scalePrice.formattedValue }}
                </span>
              </div>
            </ng-container>
            <ng-template #showSinglePrice>
              <div class="product-detail__price-wrapper">
                {{ 'productDetail.priceLabel' | cxTranslate: { unit: price.items[0].unit } }}
                <span class="product-detail__price" [attr.data-cy]="'variant-detail-price'">
                  {{ price.items[0].itemNetPricePerUnit?.formattedValue }}
                </span>
              </div>
            </ng-template>
          </div>

          <!-- AVAILABILITY -->
          <ng-container *ngIf="availabilityLoading; else availabilityTemplate">
            <eb-spinner class="product-detail__availability-spinner" size="2"></eb-spinner>
          </ng-container>
          <ng-template #availabilityTemplate>
            <eb-product-availability
              [availability]="availabilityItem"
              [error]="availabilityError"
            ></eb-product-availability>
          </ng-template>
        </ng-container>
      </ng-template>

      <!-- ADD TO CART -->
      <div class="product-detail__add-to-cart">
        <eb-purchase-product
          [product]="product"
          [hasPrice]="hasPrice(product)"
          (newQuantity)="handleQuantityChange($event)"
          [isVariantProduct]="product.ebProductType"
          [showSuccessor]="hasSuccessor(product)"
        ></eb-purchase-product>
      </div>

      <!-- SUCCESSOR FOR L5 -->
      <div *ngIf="product.isExpiring && hasSuccessor(product)">
        <eb-info-box [title]="'successor.title'" icon="bell" infoType="WARN"></eb-info-box>
        <eb-successor [orderable]="false"></eb-successor>
      </div>
    </ng-container>

    <!-- NOT L1, L2 OR L3 -->
    <ng-template #notOrderableSection>
      <div *ngIf="hasSuccessor(product); else showRequestProduct">
        <!-- ADD TO CART -->
        <div class="product-detail__add-to-cart">
          <eb-add-to-cart
            [product]="product"
            [isAvailable]="!hasSuccessor(product) && product.orderable"
            (newQuantity)="handleQuantityChange($event)"
          ></eb-add-to-cart>
        </div>

        <!-- SUCCESSOR -->
        <eb-info-box
          [title]="'successor.title'"
          text="successor.text"
          icon="bell"
          infoType="WARN"
        ></eb-info-box>
        <eb-successor [orderable]="product.orderable"></eb-successor>
      </div>
      <ng-template #showRequestProduct>
        <a
          [routerLink]="['/rfp']"
          [queryParams]="{ productCode: product.code, productName: product.name }"
          class="product-detail__request-product-btn"
          data-cy="rfp-link"
          (click)="requestRfpEvent(product.code)"
        >
          {{ 'requestProduct.sendRequest' | cxTranslate }} <em class="fas fa-envelope"></em>
        </a>
        <eb-info-box
          text="requestProduct.text"
          icon="exclamation-triangle"
          infoType="DANGER"
        ></eb-info-box>
      </ng-template>
    </ng-template>
  </ng-container>

  <!-- PRODUCT DESCRIPTION -->
  <div *ngIf="product.description" class="product-detail__description">
    <div ebTruncateText [productType]="product.ebProductType">
      <div
        #descriptionDiv
        class="product-detail__description-text"
        data-cy="product-description"
        [innerHTML]="product.description"
      ></div>
    </div>
    <div
      *ngIf="isVariant(product.ebProductType)"
      class="product-detail__legal-notice"
      [attr.data-cy]="'legal-text'"
    >
      {{ 'productDetail.legalNotice' | cxTranslate }}
    </div>
  </div>
</ng-container>
